import {Card, Divider} from 'antd';
import AOS from 'aos';
import {useEffect} from 'react';
import 'aos/dist/aos.css';
import {
  FaMedal,
  FaTools,
} from 'react-icons/fa';
import {GiWoodBeam} from 'react-icons/gi';
import {
  MdOutlineSupportAgent,
  MdSupportAgent,
} from 'react-icons/md';
import {RiDraftLine, RiFlowChart} from 'react-icons/ri';

import data from '../../data/data.json';

const iconMap = {
  FaMedal: <FaMedal className={'text-3xl text-primary-600'} />,
  FaTools: <FaTools className={'text-5xl text-primary-600'} />,
  GiWoodBeam: <GiWoodBeam className={'text-5xl text-primary-600'} />,
  MdOutlineSupportAgent: <MdOutlineSupportAgent className={'text-5xl text-primary-600'} />,
  MdSupportAgent: <MdSupportAgent className={'text-5xl text-primary-600'} />,
  RiDraftLine: <RiDraftLine className={'text-5xl text-primary-600'} />,
  RiFlowChart: <RiFlowChart className={'text-3xl text-primary-600'} />,
};

const OurProcess = () => {
  const processData = data.OurProcess;

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  return (
    <div className={'w-full flex flex-col justify-center items-center lg:px-20 px-5 lg:py-20 py-10 bg-[#ffffff]'}>
      <div className={'max-w-7xl w-full'}>
        {/* Heading Section */}
        <div className={'mb-12 text-left'} data-aos={'fade-up'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-4xl text-primary-900 mb-4'}>
            {processData.heading}
          </h1>
          <p className={'text-lg text-gray-600 max-w-3xl'}>
            {processData.subheading}
          </p>
        </div>

        {/* Process Section */}
        <Divider
          orientation={'center'}
          data-aos={'fade-in'}
          data-aos-delay={'100'}
        >
          <span className={'text-2xl font-semibold text-primary-800 playfair-display-medium'}>
            Step-by-Step Process
          </span>
        </Divider>

        <div className={'flex flex-wrap justify-center gap-6 mt-8 mb-16'}>
          {processData.processSteps.map((step, index) => (
            <Card
              key={index}
              data-aos={'fade-up'}
              data-aos-delay={index * 150} // staggered entry
              hoverable
              className={'w-full bg-primary-50 sm:w-[48%] lg:w-[30%] rounded-2xl shadow-md hover:shadow-xl transition-all duration-300'}
            >
              <div className={'flex flex-col items-center text-center space-y-3'}>
                <div className={'animate-fade-in'}>{iconMap[step.icon]}</div>
                <h3 className={'text-xl font-semibold'}>{step.title}</h3>
                <p className={'text-gray-600'}>{step.description}</p>
              </div>
            </Card>
          ))}
        </div>

        {/* Quality Standards Section */}
        <Divider
          orientation={'center'}
          className={'mt-20'}
          data-aos={'fade-in'}
          data-aos-delay={'100'}
        >
          <span className={'text-2xl font-semibold text-primary-800 playfair-display-medium'}>
            Quality & Standards
          </span>
        </Divider>

        <div className={'flex flex-wrap justify-start gap-8 mt-8'}>
          {processData.qualityHighlights.map((item, index) => (
            <div
              key={index}
              data-aos={'zoom-in'}
              data-aos-delay={index * 150}
              className={'bg-primary-50 p-6 w-full sm:w-[48%] lg:w-[30%] rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 text-center'}
            >
              <div className={'flex justify-center mb-4'}>{iconMap[item.icon]}</div>
              <h4 className={'text-xl font-semibold mb-2'}>{item.title}</h4>
              <p className={'text-gray-600'}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurProcess;
